import * as React from 'react';
import { Form as FormikForm } from 'formik';

import { Button, FormObjectList } from 'src/components';
import FieldSwitcher from './FieldSwitcher';
import { primaryFactory } from 'src/services/themeColors';
import { IForm } from '../types';

const H2Primary = primaryFactory('h2');

const Form = ({
  duplicateId,
  errors,
  isSubmitting,
  isValidatingData,
  isLoading,
  isTargetChecking,
  targetCheckResult,
  confirmDuplicate,
  onAdd,
  onReset,
  children,
}: IForm) => (
  <FormikForm autoComplete="off">
    {children}
    <div className="py-8 px-10 mb-8 bg-grey rounded">
      <H2Primary className="font-normal mb-8">
        Create New Link{' '}
        {duplicateId && (
          <small className="ml-2 opacity-50">
            (duplicating{' '}
            <code className="font-mono text-base">{duplicateId}</code>)
          </small>
        )}
      </H2Primary>
      <div className="flex flex-wrap items-start max-w-xl m-auto">
        {isLoading ? (
          <div className="loader flex-1 h-16" />
        ) : (
          <FormObjectList name={'linkCreationRequestParameters'}>
            {({ name, item }) => (
              <FieldSwitcher
                name={name}
                item={item}
                onAdd={onAdd}
                isTargetChecking={isTargetChecking}
                targetCheckResult={targetCheckResult}
              />
            )}
          </FormObjectList>
        )}
      </div>

      <div className="text-yellow">
        {errors.linkCreationRequestParameters &&
          errors.linkCreationRequestParameters.join(', ')}
      </div>
    </div>
    {confirmDuplicate && (
      <div className="text-center bg-yellow py-6 px-4 mb-8">
        <p className="mb-4">
          Link already exists, are you sure you still want to create it?
        </p>
        <Button
          className="mx-2"
          primary={true}
          background="yellow"
          type="submit"
          loading={isSubmitting}
          disabled={isLoading || isValidatingData}
        >
          Confirm
        </Button>
      </div>
    )}
    <div className="text-center mb-16">
      <Button
        className="mx-2"
        primary={true}
        type="button"
        disabled={isSubmitting}
        onClick={onReset}
      >
        Reset
      </Button>
      <Button
        className="mx-2"
        type="submit"
        loading={isSubmitting}
        loadingLabel="Creating link"
        disabled={isLoading || isValidatingData}
      >
        Create link
      </Button>
    </div>
  </FormikForm>
);

export default Form;



// WEBPACK FOOTER //
// ./src/views/LinkCreate/components/Form.tsx